import React, { FC, useState } from 'react';
import { iconSize } from '../../../../../constants/icon.constants';
import Icon from '../../../icon';

export type TAccordionProps = {
  accordionTitle?: JSX.Element;
  accordionOptions?: Partial<{
    id?: string;
    title?: JSX.Element | string;
  }>[];
  handleOptionClick?: (selectedOptionInd, event: React.MouseEvent<HTMLLabelElement, MouseEvent>) => void;
  selectedOptionInd?: number;
  canShowAccordionContent?: boolean;
  handleSwitchClick?: () => void;
  isToggleIndependent?: boolean;
};

const Accordion: FC<TAccordionProps> = ({
  accordionTitle: title = '',
  accordionOptions = [],
  handleOptionClick,
  selectedOptionInd: checkedOptInd = 0,
  canShowAccordionContent = false,
  handleSwitchClick,
  isToggleIndependent = true,
}) => {
  const [shouldShowAccordion, setShouldShowAccordion] = useState(false);
  const isAccordionOpen = isToggleIndependent ? shouldShowAccordion : canShowAccordionContent;

  return (
    <div className="filter-accordion">
      <div
        className={`filter-accordion__switch${isAccordionOpen ? ' filter-accordion__switch--open' : ''}`}
        onClick={isToggleIndependent ? () => setShouldShowAccordion(!shouldShowAccordion) : handleSwitchClick}
      >
        {title}
        <Icon
          iconName={`arrow-chevron-${isAccordionOpen ? 'up' : 'down'}`}
          size={iconSize['dsk']}
          color="light-black"
          extraClassName="filter-accordion__arrow-icon"
        />
      </div>
      {isAccordionOpen && (
        <div className="filter-accordion__panel">
          {accordionOptions?.map((eachDropdownItem, index) => (
            <label
              htmlFor={eachDropdownItem.id}
              className="filter-accordion__panel-item"
              key={eachDropdownItem.id}
              onClick={(event) => handleOptionClick?.(index, event)}
            >
              <input
                type={'radio'}
                id={eachDropdownItem.id}
                readOnly
                checked={checkedOptInd === index}
                className="filter-accordion__panel-radio"
              />
              <Icon
                iconName={checkedOptInd === index ? 'action-radio-checked' : 'action-radio-default'}
                size={iconSize.dsk}
                color="gray"
                extraClassName="filter-accordion__panel-radio-icon"
              />
              <span>{eachDropdownItem.title}</span>
            </label>
          ))}
        </div>
      )}
    </div>
  );
};

export default Accordion;
